import React , { useState , useEffect } from 'react';
import QrReader from 'react-qr-reader';
import { store } from 'react-notifications-component';
import { useGlobalContext } from '../../context/GlobalContext';
import { resetUserAction, updateUserLunchPresenceAction } from '../../../actions/usersActions';

import pouce from "../../../assets/images/icons/pouce.svg"

export default function LunchQRcodeReader(props) {

  const { setIsBadgeValid } = props;

  const [ context, dispatch ] = useGlobalContext();
  const [ isScanned , setIsScanned ] = useState(false);
  const [ user , setUser ] = useState();
  const [ scanError , setScanError ] = useState(null);

  useEffect(() => {
    if (context.users.user && context.users.user.lunchHere && context.users.user.lunchHere.find(item => item === props.event)) {
      setUser(context.users.user);
      setIsScanned(true);
      setIsBadgeValid(true)
      setScanError(null);
    }

  }, [context.users.user , props.event , setIsBadgeValid ]);

  async function handleScan(id) {
    if (id) {
      const result = await updateUserLunchPresenceAction(dispatch , id, props.event);
      if (result && result.ok === false) {
        setScanError(result.error || 'Paiement du déjeuner requis pour ce jour.');
        store.addNotification({
          message: result.error || 'Paiement du déjeuner requis pour ce jour.',
          type: "danger",
          insert: "top",
          container: "bottom-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true
          }
        });
      }
    }
  }

  function handleError(err) {
    console.error(err)
  }

  function displayScan() {
    resetUserAction(dispatch);
    setIsScanned(false)
    setScanError(null);
  }

  return (
    <>
      {!isScanned ?
        <div className="qr-container">
          <div className="qr">
            <QrReader
              delay={300}
              onError={handleError}
              onScan={handleScan}
              style={{ width: '100%' }}
            />
          </div>
          {scanError &&
            <p className="text-error" style={{ color: '#c00', marginTop: 12, textAlign: 'center' }}>
              {scanError}
            </p>
          }
        </div>
        :
        <div className="scan-result-container">
          <div className="scan-result">
            <img src={pouce} alt= "is-valid"/>
            <h2>Repas validé</h2>
            <h1 className="bold">{user.profile.firstName} {user.profile.lastName}</h1>
            <button
              onClick={() => displayScan()}
              className="btn-edit">
              Scanner un autre badge
            </button>
          </div>
        </div>
      }
    </>
  )
}
